import { ReactNode } from 'react';
import { OpenStubhubDropdownAction } from 'src/components/common/OpenSubhubDropdownAction';
import { EventItemHeaderType } from 'src/components/Events/EventItemHeader/EventItemHeader';
import { AddPurchaseAction } from 'src/components/Purchases/PurchaseTileActionDropdown/components/AddPurchase';
import { useContent } from 'src/contexts/ContentContext';
import { PosDropdown } from 'src/core/POS/PosDropdown';
import { vars } from 'src/core/themes';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { usePosLiteAccount } from 'src/hooks/usePosLiteAccount';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { SolidMoreIcon } from 'src/svgs';
import { IconsFill, MoreIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { Permission } from 'src/WebApiController';

import { LaunchAddSeatSaver } from './components/AddSeatSaverAction';
import { EnterCompanionMode } from './components/EnterCompanionModeAction';
import { LaunchMergeListings } from './components/MergeListingsAction/LaunchMergeListings';

export const InventoryEventActionDropdown = ({
  isEventPage,
  extraDropdownItems,
  triggerClassName,
  useNewMoreIcon = false, // TODO: make it true
  ...props
}: EventItemHeaderType & {
  isEventPage?: boolean;
  extraDropdownItems?: ReactNode;
  triggerClassName?: string;
  useNewMoreIcon?: boolean;
}) => {
  const actionsMsg = useContent(ContentId.Actions);
  const { event } = props;
  const isMobile = useMatchMedia('mobile');
  const hasUpdateListingInfoPermission = useUserHasAnyOfPermissions(
    Permission.Inventory_UpdateListingInfo
  );
  const isPosLite = usePosLiteAccount();

  return (
    <>
      <PosDropdown
        key="event-action-dropdown"
        trigger={
          <div
            title={actionsMsg}
            style={{
              padding: useNewMoreIcon
                ? undefined
                : `0 ${vars.spacing.sm} 0 ${vars.spacing.xxs}`,
            }}
            className={triggerClassName}
          >
            {useNewMoreIcon ? (
              <SolidMoreIcon
                withHoverEffect
                size={vars.iconSize.s}
                fill={vars.color.textBrand}
              />
            ) : (
              <MoreIcon
                withHoverEffect
                fill={IconsFill.textBrand}
                align="middle"
              />
            )}
          </div>
        }
        align="end"
      >
        <OpenStubhubDropdownAction event={event} />
        {!isMobile && <EnterCompanionMode event={event} />}
        {props.entityCount >= 2 ? (
          <>
            {hasUpdateListingInfoPermission && (
              <LaunchMergeListings event={event} />
            )}
          </>
        ) : null}

        <LaunchAddSeatSaver events={[event]} />
        {!isPosLite && <AddPurchaseAction event={event} />}

        {extraDropdownItems}
      </PosDropdown>
    </>
  );
};
